import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("repsnap_token");
    if (!token) { setUser(null); setUsage(null); setLoading(false); return; }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data.user); setUsage(r.data.usage);
    } catch { localStorage.removeItem("repsnap_token"); setUser(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("repsnap_token", r.data.token);
    await refresh();
  }, [refresh]);
  const register = useCallback(async (name, email, password, role = "athlete") => {
    const r = await api.post("/auth/register", { name, email, password, role });
    localStorage.setItem("repsnap_token", r.data.token);
    await refresh();
  }, [refresh]);
  const logout = useCallback(() => { localStorage.removeItem("repsnap_token"); setUser(null); setUsage(null); }, []);

  const value = useMemo(() => ({ user, usage, loading, login, register, logout, refresh }), [user, usage, loading, login, register, logout, refresh]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
